// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","secondary":"#33C370","wrapper":"_2_2y5rQtXAYGUxEGu092-y","item":"SOr2U76n3Ou39ssAYEMHu","item-title":"DCKl3rXFGzfehtmMi_APm","item-value":"_3qcE-P4BzWBCygo4K-7c3P"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/SummaryStep.mod.css
// module id = 1724
// module chunks = 0